(function ($, window) {
    "use strict";
    let isMobile = DSV.tools.screenMode.currentMode < (DSV.tools.screenSizes.desktop + 1) || window.innerWidth === 1024;
    let isScreensizeLarge = DSV.tools.screenMode.currentMode === DSV.tools.screenSizes.large; //1024-1280
    let isScreensizeLargest = DSV.tools.screenMode.currentMode === DSV.tools.screenSizes.xxlarge; //above 1440
    const header = document.querySelector('.header');

    DSV.ui.mainNavigation = {
        //Check for selected items in navigation - defined in BE
        detectActiveItems() {
            const mainNav = document.querySelector('.nav');
            const mainNavItems = mainNav.querySelectorAll('.nav__main-item a');
            const subNavItems = mainNav.querySelectorAll('.nav__sub-item a');
        
            [...mainNavItems].forEach( (mainItem, i) => {
                const selectedMainItem = mainItem.classList.contains('selected');
                if (selectedMainItem) {
                    mainItem.closest('.nav__main').classList.add('active-subnav');
                    mainNav.classList.add('active-item');
                }
            });
        
            [...subNavItems].forEach( (subItem, i) => {
                const selectedSubItem = subItem.classList.contains('selected');
                if (selectedSubItem) {
                    subItem.closest('.nav__sub').classList.add('active-sub-item');
                    mainNav.classList.add('active-item');
                }
            });
        },

        //if current page is below level 2 in menu structure, we need to append deep submenu in mobile navigation
        handleDeepNavigation() {

            fetch(`${this.getParentMenuUrl}?contextItemId=${this.contextId}`)
                .then(response => response.json())
                .then(json => {

                    const submenu = [];

                    const addSubmenu = (json) => {
                        if(json.HasChildren) {

                            submenu.push(json.Children);

                            const subChildren = json.Children.filter(child => (child.Selected && child.HasChildren));

                            if(subChildren.length) {
                                addSubmenu(subChildren[0]);
                            }
                        }
                    };
                    addSubmenu(json);

                    //append each submenu in the right place
                    for(let i = 0; i < submenu.length; i++ ) {
                        const baseItem = document.querySelectorAll('.nav__sub-item .selected')[i];

                        //if no selected item - do nothing...use case is country sites who does not exist in nav context
                        if(baseItem) {
                            const listElement = baseItem.parentNode;
                            this.renderSubmenu(submenu[i], listElement);
                            this.addExpandButtons();
                        }
                    }

                })
                .then(() => {
                    //expand all the newly created submenus
                    this.toggleNavItems();
                })
                .catch(error => {
                    window.console.error(error)
                })
        },

        // Toggle subnav on mobile
        toggleNavItems() {
            const toggleBtns =  document.querySelectorAll('.nav__expand-toggle');
            
            for (let i = 0; i < toggleBtns.length; i++) {
                const btn = toggleBtns[i];
                const item = btn.parentNode;
                const content =  item.nextElementSibling;
                
                // Expand navItems subNav i subNav contains selected item
                if(item.classList.contains('selected') && content && content.querySelector('.selected')) {
                    item.classList.add('expand')
                    btn.classList.add('toggle--open');
                }
                
                if(isMobile && !DSV.tools.hasClass(btn, 'btn--initialized')) {
                    btn.classList.add('btn--initialized');

                    btn.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.showSubmenu(e.target);
                    });

                } else {
                    TweenLite.set(content, {clearProps: "all"});  
                }
            }            
        },

        showSubmenu(elem) {
            const parent = elem.parentNode;
            const submenuIsExists = DSV.tools.hasClass(parent.nextElementSibling, 'nav__sub--initialized');
            const listElement = parent.parentNode;

            const itemId = parent.getAttribute('data-item-id');

            if(!submenuIsExists)  {
                fetch(`${this.getChildMenuUrl}?itemId=${itemId}&contextItemId=${this.contextId}`)
                    .then(response => response.json())
                    .then(json => {
                        this.submenu = json;
                        //this.renderLoader(false);
                        this.renderSubmenu(this.submenu, listElement);

                    })
                    .then(() => {
                        this.setup();
                        this.toggleItem(elem);
                    })
                    .catch(error => {
                        //this.renderLoader(false);
                        //this.displayErrorMessage("Sorry. There seems to be an error loading submenu. Please try again");
                        window.console.error(error)
                    })
            } else {
                this.toggleItem(elem);
            }
        },

        renderSubmenu: function(itemArray, parent) {

            if (!Array.isArray(itemArray)) {
                return '';
            }

            const submenuElement = parent.querySelector('ul.nav__sub');

            for (let i = 0, l = itemArray.length; i < l; i += 1) {
                const itemData = itemArray[i];
                const label = itemData.NavigationModel.NavigationTitle;
                const url = itemData.NavigationModel.Link.Url;
                const dataItemId = itemData.Id.Guid;
                const hasChildren = itemData.HasChildren;
                const isSelected = itemData.Selected;
                const markup = `<li class="nav__sub-item" ${hasChildren ? 'data-has-children' : ''}>
                                    <a href="${url}" class="${hasChildren ? 'expandable' : ''} ${isSelected ? 'selected' : ''}" data-item-id="${dataItemId}">
                                    ${label}
                                    </a>
                                </li>`;


                DSV.tools.addClass(submenuElement, 'nav__sub--initialized' );
                submenuElement.insertAdjacentHTML('beforeend', markup);
            }

        },

        toggleItem(elem) {

            const parent = elem.parentNode;
            const content = parent.nextElementSibling;

            TweenLite.set(content, {height: "auto"});
            
            if (!parent.classList.contains('expand')) {
                parent.classList.add('expand');
                elem.classList.add("toggle--open");
                TweenLite.from(content, 0.3, {height:0, clearProps:"all"});
            } else {
                elem.classList.remove("toggle--open");
                TweenLite.to(content, 0.3, { height:0, clearProps:"all",
                    onComplete: function(){
                        parent.classList.remove('expand');
                    }
                });
            }  
        },
           

        // Slide subnav down/up on mouseover on desktop
        toggleSubnav() {
            const mainNavItems = document.querySelectorAll('.nav__main-item');
            
            for (let i = 0; i < mainNavItems.length; i++) {
                const mainItem = mainNavItems[i];
                const subNav = mainItem.querySelector('.nav__sub');

                if (subNav) {
                    if (!isMobile) {

                        mainItem.addEventListener('mouseenter', (e) => {
                            e.preventDefault();
                            TweenLite.from(subNav, 0.6, {y: "-20px", opacity: 1, display: "none"});
                            TweenLite.to(subNav, 0.6, {y: " 0%", opacity: 1, display: "block"});
                        });
                        
                        mainItem.addEventListener('mouseleave', (e) => {
                            e.preventDefault();
                            TweenLite.to(subNav, 0.3, {y: "-20px", opacity: 0, display: "none"});
                        })
                    } else {
                        TweenLite.set(subNav,{clearProps: "all"});
                    }
                }
            }
        },

        addExpandButtons() {
            if (isMobile) {
                const subNavItemsWithChildren = document.querySelectorAll('.nav__sub-item[data-has-children]:not(.nav__sub-item--initialized) > a');

                for (let i = 0; i < subNavItemsWithChildren.length; i++) {
                    const linkTag = subNavItemsWithChildren[i];
                    const btn = document.createElement("BUTTON");   // Create a <button> element
                    btn.innerHTML = `<span class="icon--expand"></span>`;
                    btn.className = "nav__expand-toggle";
					btn.setAttribute('aria-label', 'Click to expand sub navigation');
                    linkTag.appendChild(btn);
                    DSV.tools.addClass(linkTag, 'expandable' );
                    DSV.tools.addClass(linkTag.parentNode, 'nav__sub-item--initialized' );

                    //create empty container for subnav
                    const submenuUL = document.createElement("UL");   // Create a <ul> element
                    submenuUL.className = "nav__sub";
                    linkTag.parentNode.appendChild(submenuUL);
                }
            }
        },

        // Debounce
        debounce(delay, func) {
            let timerId;
            return function(...args) {
                if (timerId) {
                    clearTimeout(timerId);
                }
                timerId = setTimeout(() => {
                    func(...args);
                    timerId = null;
                }, delay)
            }
        }, 
        
        setup() {
            //Mobile menu is active from 0 - 1024px window width. 1024px included
            isMobile = DSV.tools.screenMode.currentMode < (DSV.tools.screenSizes.desktop + 1) || window.innerWidth === 1024;

            isScreensizeLarge = DSV.tools.screenMode.currentMode === DSV.tools.screenSizes.large; //1024-1280
            isScreensizeLargest = DSV.tools.screenMode.currentMode === DSV.tools.screenSizes.xxlarge; //above 1440

            this.detectActiveItems(); //sets active class dependent on selected
            this.addExpandButtons(); //adds expand btns to DOM
            this.toggleNavItems(); //adds btn event click
            this.toggleSubnav(); //show/hides subnav on desktop

            if (isMobile && this.menulvl > 2 && !this.deepNavInitialized) {
                this.handleDeepNavigation();
                this.deepNavInitialized = true;

            }
        },
    
        resizeHandler() {
            const debounce = this.debounce(500, () => this.setup());
            window.addEventListener('resize', () => debounce());
        },

        init() {
            this.hostUrl = window.location.protocol + '//' + window.location.host;
            this.getChildMenuUrl = `${this.hostUrl}/api/sitecore/menu/GetMenuItemChildren`;
            this.getParentMenuUrl = `${this.hostUrl}/api/sitecore/menu/GetMenuItemParents`;
            this.contextId = document.querySelector('.nav').getAttribute('data-context-item-id');
            this.menulvl = document.querySelector('.nav').getAttribute('data-current-menu-level');
            this.deepNavInitialized = false;

            this.setup();
            this.resizeHandler();
        }
    };

})(jQuery, window);